/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function KeycloakConfigurationRepresentationFromJSON(json) {
    return KeycloakConfigurationRepresentationFromJSONTyped(json, false);
}
export function KeycloakConfigurationRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        realm: json['realm'],
        auth_server_url: json['auth-server-url'],
        ssl_required: json['ssl-required'],
        resource: json['resource'],
        public_client: json['public-client'],
        verify_token_audience: json['verify-token-audience'],
        use_resource_role_mappings: !exists(json, 'use-resource-role-mappings')
            ? undefined
            : json['use-resource-role-mappings'],
        confidential_port: json['confidential-port'],
    };
}
export function KeycloakConfigurationRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        realm: value.realm,
        'auth-server-url': value.auth_server_url,
        'ssl-required': value.ssl_required,
        resource: value.resource,
        'public-client': value.public_client,
        'verify-token-audience': value.verify_token_audience,
        'use-resource-role-mappings': value.use_resource_role_mappings,
        'confidential-port': value.confidential_port,
    };
}
